import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export default function Dealers() {
  const navigate = useNavigate();
  return (
    <div className="max-w-5xl mx-auto px-4 lg:px-8 py-16" data-testid="dealers-page">
      <div className="text-xs uppercase tracking-wider text-teal-700 font-semibold mb-3">For dealers</div>
      <h1 className="text-4xl lg:text-5xl font-semibold text-slate-900">Move inventory faster with CarFin.</h1>
      <p className="mt-5 text-slate-600 max-w-3xl leading-relaxed">Onboard customers, upload CarDr reports, track approvals and dealer payouts — all from one dashboard. Free for verified used car dealers.</p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-10">
        {[
          { t: "Inventory friendly", d: "Vehicle-first underwriting. CarDr grade decides LTV, not gut feel." },
          { t: "Higher conversion", d: "Pre-qualification engine lets you show customers a realistic offer in 5 minutes." },
          { t: "Dealer payout tracker", d: "Track sanctions and disbursements vehicle-by-vehicle." },
        ].map((b, i) => (
          <Card key={i} className="p-5 border-slate-200">
            <div className="font-semibold text-slate-900">{b.t}</div>
            <div className="text-sm text-slate-600 mt-2">{b.d}</div>
          </Card>
        ))}
      </div>
      <div className="mt-12 flex gap-3">
        <Button className="bg-teal-600 hover:bg-teal-700" onClick={() => navigate("/contact")} data-testid="dealer-cta-onboard">Onboard as Dealer</Button>
        <Button variant="outline" onClick={() => navigate("/login")}>Dealer Sign in</Button>
      </div>
    </div>
  );
}
